import { FaGoogle } from 'react-icons/fa';

export default function FormSocial() {
  return (
    <div className="">
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-sm font-medium leading-6 py-4">
          <span className="bg-white px-2 text-gray-500">OR</span>
        </div>
      </div>
      <div className="text-sm grid grid-cols-3 gap-4">
        <a
          className="justify-center justify-items-center flex border border-gray-200 rounded-md py-3 col-start-2"
          href={`/auth/google${window.location.search}`}
        >
          <FaGoogle />
        </a>
      </div>
    </div>
  );
}
